export default "__VITE_ASSET__CuP6Urzh__"